<template>
  <div class="page-outbox">
  	<!--地址栏-->
  	<div class="addr-info" @click="selectAddr">
      <h3 class="block-title">收货地址</h3>
  		<div class="empty-info" v-if="!$store.state.selectedAddrData.ca_name">请选择地址</div>
  		<div v-else>
  			<h3 class="addr-user"><label class="name">{{$store.state.selectedAddrData.ca_name}}</label><span class="telNum">{{$store.state.selectedAddrData.ca_mobile}}</span></h3>
	    	<p class="addr-area">
	    		<span class="area">{{$store.state.selectedAddrData.ca_province}}</span><span class="area">{{$store.state.selectedAddrData.ca_city}}</span>
	    		<span class="area">{{$store.state.selectedAddrData.ca_county}}</span><span class="area">{{$store.state.selectedAddrData.ca_street}}</span>
	    	</p>
  		</div>
  	</div>
  	<div class="addr-info" @click="selectInvoiceAddr">
      <h3 class="block-title">收票地址</h3>
  		<div class="empty-info" v-if="!$store.state.selectedInvoiceAddrData.cia_name">请选择地址</div>
      <div v-else>
        <h3 class="addr-user"><label class="name">{{$store.state.selectedInvoiceAddrData.cia_name}}</label><span class="telNum">{{$store.state.selectedInvoiceAddrData.cia_mobile}}</span></h3>
        <p class="addr-area">
          <span class="area">{{$store.state.selectedInvoiceAddrData.cia_province}}</span><span class="area">{{$store.state.selectedInvoiceAddrData.cia_city}}</span>
          <span class="area">{{$store.state.selectedInvoiceAddrData.cia_county}}</span><span class="area">{{$store.state.selectedInvoiceAddrData.cia_street}}</span>
        </p>
      </div>
  	</div>
    <!--是否开发票-->
    <div class="need-invoice-group">
      <p @click="needInvoiceSwitch(true)"><i class="mint-checkbox-core" :class="{'checked':needInvoice}"></i>开票</p>
      <p @click="needInvoiceSwitch(false)"><i class="mint-checkbox-core" :class="{'checked':!needInvoice}"></i>不开票</p>
    </div>


    <!--发票信息-->
  	<div class="invoice-info" @click="selectInvoice" v-if="needInvoice">
      <h3 class="invoice-title">发票信息</h3>
  		<div class="empty-info" v-if="!$store.state.selectedInvoiceData.ci_id">请选择发票</div>
  		<div class="invoice-item" v-else>
        <i class="invoice-type-icon">{{['','普','专'][$store.state.selectedInvoiceData.ci_type]}}</i>
        <h3 class="invoice-info-item">
          <label class="value"><span class="name" v-if="$store.state.selectedInvoiceData.ci_type==2">抬头：</span>{{$store.state.selectedInvoiceData.ci_title}}</label>
          <label class="value"><span class="name" v-if="$store.state.selectedInvoiceData.ci_type==2">税号：</span>{{$store.state.selectedInvoiceData.ci_vatno}}</label>
        </h3>
        <h3 class="invoice-info-item" v-if="$store.state.selectedInvoiceData.ci_type=='2'">
          <label class="value"><span class="name">银行：</span>{{$store.state.selectedInvoiceData.ci_bank}}</label>
          <label class="value"><span class="name">账号：</span>{{$store.state.selectedInvoiceData.ci_bknum}}</label>
        </h3>
        <h3 class="invoice-info-item" v-if="$store.state.selectedInvoiceData.ci_type=='2'">
          <label class="value"><span class="name">地址：</span>{{$store.state.selectedInvoiceData.ci_addr}}</label>
          <label class="value"><span class="name">电话：</span>{{$store.state.selectedInvoiceData.ci_phone}}</label>
        </h3>
  		</div>

  	</div>
  	<div class="other-info">
  		<!--买方采购单号-->
	  	<!--<mt-field label="买方采购单号" class="inputcontent" placeholder="请输入买方采购单号" v-model="buyNum"></mt-field>-->
	  	<!--订单备注-->
	  	<mt-field class="inputcontent" type="textarea" placeholder="请输入订单备注" v-model="extralInfo"></mt-field>
  	</div>

    <!--订单信息-->
    <ul class="order-listbox">
      <li class="order-list-item" v-for="(item,index) in orderData.goodsList" @click="toDetail(item)">
        <order-item :goodsData="item" :index="index" :readOnly="true"></order-item>
      </li>
    </ul>
    <!--金额信息-->
    <div class="price-info">
      <p class="price-group">
        <label>运费</label>
        <span>￥{{orderData.priceData.freight}}</span>
      </p>
    </div>
  	<!--提交栏-->
  	<div class="submit-bar">
  		<p class="total-price">订单金额:<span>￥{{orderData.totalPrice}}</span></p>
  		<button class="submit-btn" id="toPay" @click="toPay">提交订单</button>
  	</div>
  </div>
</template>

<script>
  import OrderItem from 'basic/orderItem/orderItem'
	export default {
		name: 'submitOrder',
    data () {
      return {
      needInvoice:false,
	    orderData: {
        goodsList:[],
        defaultAddr:{},
        defaultInvoiceAddr:{},
        invoiceInfo:{},
        priceData:{
          freight:0.00,
          dryIce:0.00
        },
        totalPrice:0
      },
	    buyNum:'',
	    extralInfo:''
      }
    },
    computed:{
    },
    mounted(){
      this.getOrderInfo()
      this.extralInfo=this.$store.state.userInfo.cus_send_note;
			if(this.$route.meta&&this.$route.meta.pageBelong){
				this.$store.commit('setPageBelong',this.$route.meta.pageBelong)
			}

			//获取焦点时移到页面可见区域
    	$('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus',function(e){
			 var dom=e.target;
				setTimeout(function(){
					dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
				}, 200);
			})

		},
    methods:{
    	selectAddr(){
    		this.$router.push({path:'/AddrList/'+true+'?isSubSelect=1'});
    	},
      selectInvoiceAddr(){
    		this.$router.push({path:'/InvoiceAddrList/'+true+'?isSubSelect=1'});
    	},
      needInvoiceSwitch(type){
    	  this.needInvoice=type;
      },
    	selectInvoice(){
    		this.$router.push({path:'/InvoiceList/'+true});
    	},
    	toPay(){
        //获取订单信息
        this.$cHttp.post('shopcart/confirm',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          ca_id:this.$store.state.selectedAddrData.ca_id,
          cia_id:this.$store.state.selectedInvoiceAddrData.cia_id,
          ci_id:this.$store.state.selectedInvoiceData.ci_id,
          so_ci_method:this.needInvoice?'1':'0',
          so_note:this.extralInfo,
          cus_invoice_method:this.$store.state.userInfo.cus_invoice_method,
          cus_free_express:this.$store.state.userInfo.cus_free_express,
          cus_send_note:this.$store.state.userInfo.cus_send_note
        }).then((res)=>{
          console.log(res);
          if(res.status&&res.status==1){
            this.$toast('订单提交成功!');
            this.$store.commit('setSubOrderInfo',{
              cus_prepay:Number(res.data.cus_prepay),
              so_no:res.data.so_no,
              so_id:res.data.so_id,
              so_total:Number(res.data.so_total),
              so_ci_method:res.data.so_ci_method
            });
            console.log(this.$store.state.subOrderInfo);
            this.$store.commit('setShopCount',res.total_num);
            this.$router.push({path:'/PayInfo/'});
          }else{
            this.$toast(res.error_msg)
          }
        }).catch((msg)=>{
          this.$toast(msg);
      })
    		//this.$router.push({path:'/payInfo'})
    	},
			toDetail(item){
        	// this.$router.push({path:'/GoodsDetail/'+item.id})
      },
      getOrderInfo(){
    	  //获取订单信息
        this.$cHttp.post('shopcart/checkout',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          cus_free_express:this.$store.state.userInfo.cus_free_express
        }).then((res)=>{
          if(res.status&&res.status==1){
            console.log(res)
            this.orderData.goodsList=res.data.items;
            this.orderData.defaultAddr={
              ca_city:res.data.ca_city,
              ca_county:res.data.ca_county,
              ca_id:res.data.ca_id,
              ca_if_default:res.data.ca_if_default,
              ca_mobile:res.data.ca_mobile,
              ca_name:res.data.ca_name,
              ca_phone:res.data.ca_phone,
              ca_province:res.data.ca_province,
              ca_street:res.data.ca_street
            }
            this.orderData.defaultInvoiceAddr={
              cia_city:res.data.cia_city,
              cia_county:res.data.cia_county,
              cia_id:res.data.cia_id,
              cia_if_default:res.data.cia_if_default,
              cia_mobile:res.data.cia_mobile,
              cia_name:res.data.cia_name,
              cia_phone:res.data.cia_phone,
              cia_province:res.data.cia_province,
              cia_street:res.data.cia_street
            }
            this.orderData.invoiceInfo={
              ci_addr: res.data.ci_addr,
              ci_bank: res.data.ci_bank,
              ci_bknum: res.data.ci_bknum,
              ci_id: res.data.ci_id,
              ci_if_default: res.data.ci_if_default,
              ci_phone: res.data.ci_phone,
              ci_title: res.data.ci_title,
              ci_type: res.data.ci_type,
              ci_vatno: res.data.ci_vatno,
            }
            if(this.orderData.invoiceInfo.ci_id){
              this.needInvoice=true;
            }
            this.orderData.totalPrice=res.data.total;
            this.storeAddrInfo();
            this.getFreight();
          }else{
            this.$toast(res.error_msg)
          }

        }).catch((msg)=>{
          this.$toast(msg);
        })
      },
      getFreight(){
    	  //获取运费
        this.$cHttp.post('shopcart/express',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          ca_id:this.orderData.defaultInvoiceAddr.cia_id,
          cus_free_express:this.$store.state.userInfo.cus_free_express
        }).then((res)=>{
          if(res.status&&res.status==1){
            this.orderData.priceData.freight=res.express;
          }else{
            this.$toast(res.error_msg)
          }

        }).catch((msg)=>{
          this.$toast(msg);
        })
      },
      storeAddrInfo(){
        //将地址存起来
        if(this.$store.state.selectedAddrData.ca_id||(this.$store.state.selectedAddrData.ca_id==0&&this.$store.state.selectedAddrData.ca_id!='')){
          //地址已存在不需赋值
        }else{
          this.$store.commit('setSelectedAddrData',Object.assign(this.orderData.defaultAddr))
        }
        //将收票地址存起来
        if(this.$store.state.selectedInvoiceAddrData.cia_id||(this.$store.state.selectedInvoiceAddrData.cia_id==0&&this.$store.state.selectedInvoiceAddrData.cia_id!='')){
          //地址已存在不需赋值
        }else{
          this.$store.commit('setSelectedInvoiceAddrData',Object.assign(this.orderData.defaultInvoiceAddr))
        }
        //将发票存起来
        if(this.$store.state.selectedInvoiceData.ci_id||(this.$store.state.selectedInvoiceData.ci_id==0&&this.$store.state.selectedInvoiceData.ci_id!='')){
          //发票已存在不需赋值
        }else{
          this.$store.commit('setSelectedInvoiceData',Object.assign(this.orderData.invoiceInfo))
        }

      }
    },
    components:{
        OrderItem
    }
	}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" >

	.mint-cell{
		padding: 0;
		min-height: .4rem;
		.mint-cell-wrapper{
			padding: 0;
			font-size: .14rem;
			color: #333;
			.mint-cell-title{
				padding-right: .1rem;
				width: auto;
				min-width: .85rem;
				color: #666;
				text-align: right;
			}
			.mint-field-core{
			  max-width: none;
			  text-align: left;
			}
		}
	}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
	.empty-info{
		padding-bottom: .1rem;
		color: #999;
		line-height: .4rem;
		font-size: .14rem;
	}
	.listview{
	  position: absolute;
	  width: 100%;
	  top:.86rem;;
		left:0;
		bottom:.45rem;
	  overflow: hidden;
	}
	.addr-info{
		padding: .1rem 0 0 .1rem;
		padding-right: .2rem;
		border-bottom: 4px solid #eee;
		background:url(../../assets/nav-btn-next.png) no-repeat 98% center;
		background-size: .15rem .15rem;
		&:active{
			background-color: #eee;
		}
		.addr-user{
		 	font-size: .15rem;
		 	color: #333;
		 	line-height: .25rem;
		 	>label{
		 		padding-right: .1rem;
		 	}
		 }
		 .addr-area{
		 	padding-bottom: .05rem;
		 	font-size: .14rem;
		 	color: #999;
		 	line-height: .2rem;
		 	border-bottom: 1px dashed #eee;
		 	.area{
		 		padding-right: .04rem;
		 	}
		 }
		}
		.order-listbox{
			padding-left: .1rem;
      border-top: 4px solid #eee;
			.order-list-item{
				border-bottom: 1px solid #eee;
			}
		}
		.price-info{
			padding: .1rem;
      padding-bottom: .55rem;
			border-bottom: 1px dashed #eee;
      border-top: 4px solid #eee;
			.price-group{
				display: flex;
				height: .25rem;
				line-height: .25rem;
				font-size: .14rem;
				color: #666;
				>label{
					flex: 1;
				}
				>span{
					color:$mainColor;
				}
			}
		}
    .block-title{
      padding: .05rem 0;
      font-size: .14rem;
      color: #83caff;
    }
		.invoice-info{
			padding: .05rem .1rem;
			background:url(../../assets/nav-btn-next.png) no-repeat 98% center;
			background-size: .15rem .15rem;
			&:active{
				background-color: #eee;
			}
			.invoice-title{
				padding: .05rem 0;
				font-size: .14rem;
		 		color: #83caff;
			}
			.invoice-company{
		 	font-size: .15rem;
		 	color: #333;
		 	line-height: .25rem;
		 	>label{
		 		padding-right: .1rem;
		 	}
		 }
		 .addr-area{
		 	padding-bottom: .05rem;
		 	font-size: .14rem;
		 	color: #999;
		 	line-height: .2rem;
		 	.area{
		 		padding-right: .04rem;
		 	}
		 }
		}
		.other-info{
			padding:  .1rem .1rem 0;
		 	border-top: 4px solid #eee;
		}

  .need-invoice-group{
    display: flex;
    padding: 10px 15px;
    padding-left: .1rem;
    font-size: .14rem;
    color: #666;
    background-color: #fff;
    border-bottom: 1px dashed #eee;
    p{
      padding-right:.2rem;
    }
    .mint-checkbox-core{
      margin-right: .1rem;
      &.checked{
        background-color: $mainColor;
        border-color: $mainColor;
        &:after{
          border-color: #fff;
          transform: rotate(45deg) scale(1);
        }
      }
    }

  }
  .invoice-item{
      flex: 1;
      position:relative;
      .invoice-type-icon{
        position:absolute;
        top:0;
        right:.1rem;
        width:.15rem;
        height:.15rem;
        padding:.02rem;
        line-height: .15rem;
        text-align: center;
        font-size:.12rem;
        color:#fff;
        border-radius: .04rem;
        background-color:$mainColor;
      }
      .invoice-info-item{
        padding-right:.2rem;
        display: flex;
        box-sizing: border-box;
        flex-direction: column;
        font-size: .15rem;
        color: #333;
        line-height: .2rem;
        .name{
          padding: .02rem 0;
          font-size: 0.12rem;
          color: #aaa;
        }
      }

  }
	.submit-bar{
		display: flex;
		position:fixed;
		bottom: .45rem;
		left:0;
		right:0;
		padding-left: .1rem;
		font-size: .14rem;
		line-height: .45rem;
		border-top: 1px solid #ccc;
		background-color: #fff;
    z-index: 10;
		.check-box.all{
			padding-right: .1rem;
			display: flex;
			align-items: center;
		}
		.total-price{
			flex:1;
			>span{
				padding: 0 .08rem;
				color: $mainColor;
			}
		}
		.submit-btn{
			padding: 0 .05rem;
			font-size: .14rem;
			min-width: .8rem;
			color: #fff;
			border:none;
			background-color: #ffb820;
			&:active{
				background-color: #FFA000;
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/submitOrder/submitOrder.vue